const accountsURL = `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_ACCOUNTS}`;
export const Comments = `${accountsURL}/comments`;
export const AUDITS_EVENT = `${accountsURL}/scheduler/events`;
export const UPDATE_SCHEDULER = `${accountsURL}/scheduler/update`;
export const MilestoneDetails = `${accountsURL}/milestonestatus`;
export const OcComments = `${accountsURL}/device-level-updates/comments`;
export const LOOKUP_REVEAL_ACCOUNT_STATUS = `${process.env.REACT_APP_BASE_URL}sfdc/api/v1/account/accountNumber`;
export const ACCOUNT_SUSPEND_ACTION_BASE = `${accountsURL}/account-suspend`;
export const CREATE_ACCOUNT_LOOKUP = `${accountsURL}/create/account/prefill`;
export const CREATE_ACCOUNT_REVEAL = `${accountsURL}/create/account/legacy`;
export const DATABASE_EDITOR_SEARCH = `${accountsURL}/tools/database-editor/search`;
export const DATABASE_EDITOR_SAVE = `${accountsURL}/tools/database-editor/save`;
export const DATABASE_EDITOR_UPLOAD = `${accountsURL}/tools/database-editor/upload`;
export const EVENT_VIEWER_INITIAL = `${accountsURL}/event-viewer`;
export const EVENT_VIEWER_SEARCH = `${accountsURL}/event-viewer/search`;
export const EVENT_VIEWER_GET_EDIT = `${accountsURL}/event-viewer/edit-event`;
export const EVENT_VIEWER_POST_EDIT = `${accountsURL}/event-viewer/event-editor`;
export const EVENT_VIEWER_RETRY = `${accountsURL}/event-viewer/retry`;
export const DATABASE_STAGE_MANAGER = `${accountsURL}/tools/database-stage-manager`;
